import { useQuery } from "react-query";

import type { AgeVerificationMethodType } from "@jti/fe-common";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { AvpAPI } from "../../../services";

export const useAvpAvailableMethods = (): {
  isAvailableMethodsLoading: boolean;
  availableMethods: AgeVerificationMethodType[];
} => {
  const avpApi = AvpAPI.init();
  const { data: availableMethods, isLoading: isAvailableMethodsLoading } = useQuery(
    QUERY_KEYS.avpAvailableMethods,
    () => {
      return avpApi.getAvailableMethods();
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    availableMethods: availableMethods?.data ?? [],
    isAvailableMethodsLoading,
  };
};
